import type { ApiResponse, PlayerApiError } from '../../src/web-player/contracts.js'

export class ActivityApiError extends Error {
  constructor(readonly details: PlayerApiError) {
    super(details.message)
    this.name = 'ActivityApiError'
  }
}

function unwrap<T>(value: unknown, status: number): T {
  const response = value as ApiResponse<T> | null
  if (response?.ok === true && status >= 200 && status < 300) return response.data
  if (response?.ok === false) throw new ActivityApiError(response.error)
  throw new ActivityApiError({
    code: status === 401 ? 'UNAUTHORIZED' : 'INTERNAL_ERROR',
    message: `Best Music Boat returned an invalid response (HTTP ${status}).`,
    retryable: status >= 500,
  })
}

export async function activityRequest<T>(
  path: string,
  token?: string,
  init: RequestInit = {}
): Promise<T> {
  const headers = new Headers(init.headers)
  headers.set('Accept', 'application/json')
  if (init.body !== undefined && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  if (token) headers.set('Authorization', `Bearer ${token}`)
  const response = await fetch(`/activity/api${path}`, {
    ...init,
    headers,
    cache: 'no-store',
    signal: init.signal ?? AbortSignal.timeout(20_000),
  })
  return unwrap<T>(await response.json().catch(() => null), response.status)
}

export function activityWebSocketUrl(ticket: string): string {
  const url = new URL('/activity/ws', window.location.origin)
  url.protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  url.searchParams.set('ticket', ticket)
  return url.toString()
}
